import api from './api';

export type ProfileEventType = 'profile_view' | 'whatsapp_click';

export type ProfileEventSource = 'home' | 'search' | 'profile';

export interface CaregiverMetrics {
  period_days: number;
  profile_views: number;
  whatsapp_clicks: number;
}

// Fire and forget: tracking must never break the page for families
export function trackProfileEvent(
  slug: string,
  type: ProfileEventType,
  source: ProfileEventSource,
): void {
  api.post('/metrics/events', { slug, type, source }).catch(() => undefined);
}

// Counts one view per profile per browser session, so refreshes do not inflate it
export function trackProfileView(slug: string): void {
  const key = `@Cuid:viewed:${slug}`;

  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch {
    // Storage blocked: still count the view
  }

  trackProfileEvent(slug, 'profile_view', 'profile');
}

export interface RegionStats {
  city: string;
  uf: string;
  professionals: number;
  cost: {
    yours: number | null;
    average: number | null;
    min: number | null;
    max: number | null;
  };
  occupations: { occupation: string; count: number }[];
  formation_rate: number;
  verified_rate: number;
  photo_rate: number;
}

export const METRICS_PERIODS = [7, 30, 90] as const;

export type MetricsPeriod = (typeof METRICS_PERIODS)[number];

export async function getMetrics(
  days: MetricsPeriod = 7,
): Promise<CaregiverMetrics> {
  const response = await api.get<CaregiverMetrics>('/metrics', {
    params: { days },
  });

  return response.data;
}

export async function getRegionStats(): Promise<RegionStats> {
  const response = await api.get<RegionStats>('/metrics/region');

  return response.data;
}
